<template>
  <Modal
    width="1020"
    title="选择落地页"
    class-name="vertical-center-modal"
    v-model="state"
    :mask-closable="false"
    :closable="false"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="!show"></Spin>

    <ElForm class="elementui-common-form-styles" v-highlight label-width="70" inline>
      <Select v-model="gameId" placeholder="请输入游戏名称" style="width: 240px; margin-right: 20px" filterable clearable>
        <Option v-for="item in gameData" :key="item.id" :label="item.name" :value="item.id"></Option>
      </Select>
      <Select v-model="openId" placeholder="请输入上传者姓名" style="width: 240px; margin-right: 20px" filterable clearable>
        <Option v-for="item in openIds" :key="item.id" :label="item.name" :value="item.id"></Option>
      </Select>

      <ElInput v-model="keyword" placeholder="请输入落地页名称或ID" style="width: 240px"></ElInput>

      <ElFormItem class="bg-transparent">
        <ElButton type="primary" @click="query">查询</ElButton>
      </ElFormItem>
    </ElForm>

    <ElTable ref="table" :data="linkDataList" @row-click="clickCurrentRow" stripe height="400">
      <el-table-column label="选择">
        <template slot-scope="{ row }"> &emsp;<el-checkbox :disabled="row._disabled" :value="row.isCheck"></el-checkbox> </template>
      </el-table-column>
      <el-table-column v-for="col in linkTableHead" :width="col.width" :key="col.key" :label="col.title" :prop="col.key">
        <template slot-scope="{ row }">
          <div v-if="col.key === 'down_rate'">{{ row.down_rate | toPercentFixed }}</div>

          <div v-else>{{ row[col.key] }}</div>
        </template>
      </el-table-column>

      <el-table-column label="缩略图">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openNewTab(row)">查看</el-button>
        </template>
      </el-table-column>
    </ElTable>
    <Page :current.sync="pageIndex" :total="total" :page-size="pageSize" class="page-index" show-total @on-change="changePageIndex" />

    <template slot="footer">
      <Button type="default" @click="$emit('input', false)">取消</Button>
      <Button type="primary" @click="asyncSelect">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { getCaoHuaGames, getCaoHuaOpenIds, getCaoHuaLinks } from '@/api/common.model'
export default {
  name: 'landpage',
  components: {},
  props: {
    value: {
      type: Boolean
    },
    defaultGameId: {
      type: [String, Number]
    },
    NewTouTiaoPage: {
      type: Boolean
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    openNewTab(row) {
      window.open(row.image_addr)
    },
    // 请求数据
    getData() {
      this.linkDataList = []
      getCaoHuaLinks({
        keyword: this.keyword,
        openId: this.openId,
        gameId: this.gameId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        NewTouTiaoPage: this.NewTouTiaoPage,
        urlType: 1
      }).then((data) => {
        this.show = true
        if (data) {
          this.linkDataList = data.list.map((ret) => {
            return {
              ...ret,
              _disabled: Boolean(ret.bytedisabled)
            }
          })
          this.total = data.page_info.total_number
        }
      })
    },
    // 默认初始化
    bindGetData(e) {
      if (e) {
        this.show = null
        Promise.all([getCaoHuaGames(), getCaoHuaOpenIds()])
          .then((data) => {
            if (isArray(data) && data.every((ret) => isArray(ret))) {
              const [gameIds, openIds] = data
              this.gameData = gameIds
              this.openIds = openIds
              this.gameId = this.defaultGameId
              this.getData()
            } else {
              this.show = true
              console.error('proload data for landpage/landpage.vue pages in error. at bindgetdata function!')
            }
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        this.currentRow = undefined
        this.openId = ''
        this.gameId = ''
        this.keyword = ''
        this.pageIndex = 1
      }
    },
    query() {
      this.show = null
      this.pageIndex = 1
      this.getData()
    },
    changePageIndex(index) {
      this.show = null
      this.pageIndex = index
      this.getData()
    },
    // 选中当前项
    async clickCurrentRow(currentRow) {
      this.linkDataList.forEach((row) => {
        this.$set(row, 'isCheck', false)
      })

      await this.$nextTick()
      this.$set(currentRow, 'isCheck', true)
      this.currentRow = JSON.parse(JSON.stringify(currentRow))
    },
    asyncSelect() {
      if (!this.currentRow) {
        this.$Message.warning('您未选择一个落地页')
        return false
      }

      this.$emit('on-select', this.currentRow)
    }
  },
  data() {
    return {
      // 请求状态
      show: null,
      // 分页信息
      total: 0,
      pageIndex: 1,
      pageSize: 10,

      // 下拉数据
      gameId: undefined,
      openId: undefined,
      gameData: [],
      openIds: [],
      keyword: '',

      linkDataList: [],
      linkTableHead: [
        {
          key: 'land_page_id',
          title: '落地页ID',
          width: 70
        },
        {
          key: 'land_page_inner_name',
          title: '落地页名称',
          width: 170
        },
        {
          key: 'land_page_name',
          title: '页面名称',
          width: 170
        },
        {
          key: 'game_names',
          title: '游戏',
          tooltip: true,
          width: 200
        },
        {
          key: 'op_name',
          title: '上传者'
        },
        {
          key: 'down_rate',
          title: '下载率',
          width: 100
        },
        {
          key: 'create_time',
          title: '上传日期',
          width: 150
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.page-index {
  margin-top: 12px;
  text-align: right;
}
</style>
